import "core-js/modules/es.reflect.construct.js";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { WebApiError } from "./WebApiError";
// Error class abstraction that enables framework agnostic error handling
export var WebApiNetworkError = /*#__PURE__*/function (_WebApiError) {
  function WebApiNetworkError() {
    var _this;
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
    _classCallCheck(this, WebApiNetworkError);
    _this = _callSuper(this, WebApiNetworkError, [message, undefined, undefined]);
    // Always undefined for this type of error
    _this.httpStatusCode = undefined;
    _this.name = "WebApiNetworkError";
    return _this;
  }
  _inherits(WebApiNetworkError, _WebApiError);
  return _createClass(WebApiNetworkError);
}(WebApiError);